const CHANGE_FILTER = 'realhub/admin/taskFilters/CHANGE_FILTER'

// Initial State
const initialState = {
  filterEmployeeId: 'all',
  filterString: '',
  filterTaskTypeId: 'all',
  filterTaskStatus: 'current',
}

// Actions
export function changeFilter(name, value){
  return {
    type: CHANGE_FILTER,
    name,
    value,
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { type } = action

  switch (type){
    case CHANGE_FILTER:{
      const change = {}
      change[action.name] = action.value

      return Object.assign({}, state, change)
    }
    default:
      return state
  }
}
